import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { register } from 'swiper/element/bundle';
import { RouteTrackingService } from './route-tracking.service';

@Component({
	selector: 'cms-root',
	templateUrl: './app.component.html',
	imports: [RouterModule],
})
export class AppComponent {
	private _routeTrackingSrv = inject(RouteTrackingService);

	constructor() {
		register();
		this._routeTrackingSrv.trackRouteChange();
	}
}
